import { useAuth0 } from '@auth0/auth0-react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import { useDebouncedLoader } from 'use-debounced-loader';

export const useNewGlobalLoadingState = () => {
  const { isLoading: isAuth0Loading } = useAuth0();

  const isFetching = useIsFetching({
    // We check status here to avoid displaying the indicator on refetches
    predicate: (query) => query.state.status === 'pending' && Boolean(query.meta?.showGlobalLoader),
  });
  const isMutating = useIsMutating({
    predicate: (mutation) =>
      mutation.state.status === 'pending' && Boolean(mutation.meta?.showGlobalLoader),
  });

  // We can potentially use the meta object to provide a label to the loader here
  const what = '';

  const showIndicator = useDebouncedLoader(
    isFetching > 0 || isMutating > 0 || isAuth0Loading,
    200,
    2000,
  );

  return { showIndicator, what };
};
